import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthUser } from "./components/Authentication/authHelper";
import { toast } from "react-hot-toast";
import { socket } from "./socketGlobal";

const SocketConnection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 🔌 CONNECT ONCE
    if (!socket.connected) {
      socket.connect();
    }

    const userId = getAuthUser()?.membership_no;
    if (userId) {
      socket.emit("userConnected", userId.toString());
      console.log("Socket connected as:", userId);
    }


    // =========================
    // EVENT HANDLERS
    // =========================

    const handleNewOrder = (data) => {
      const existingOrders = JSON.parse(localStorage.getItem("orders")) || [];
      const totalOrders = [...existingOrders, data];
      localStorage.setItem("orders", JSON.stringify(totalOrders));
      navigate("/order-accept-decline", { state: totalOrders });
    };

    const handleAcceptOrder = (data) => {
      toast.success(`Your order is confirmed by ${data.meal_host}`, { duration: 4000 });
    };

    const handleDeclineOrder = (data) => {
      toast.error(`Your order was declined by ${data.meal_host}`, { duration: 4000 });
    };

    const handlePaid = (data) => {
      toast.success("Payment successful");
      navigate("/mealhost-contact", { state: data.mealhost_id });
    };

    const handleFailed = () => {
      toast.error("Unable to initiate the payment of the accepted order.");
    };

    const handleOrderDeliveredPatron = (data) => {
      toast.success("Your order is served");
      navigate("/patron-ratings", { state: data });
    };
    console.log("patron Rating Socket connect")

    const handleOrderDeliveredMealhost = (data) => {
      toast.success("You served the order");
      navigate("/mealhost-ratings", { state: data });
    };

    const handleRatingByPatron = (data) => {
      navigate("/patron-ratings", { state: data });
    };

    const handleRatingByMealhost = (data) => {
      navigate("/mealhost-ratings", { state: data });
    };

    // Handle paymentSuccess event
    const handlePaymentSuccess = (data) => {
      toast.success(`Payment Success! Order: ${data.orderId}, Amount: $${data.amount / 100 || data.amount}`);
      console.log("Received paymentSuccess event:", data);
      // Optionally, navigate or update state here
    };

    // =========================
    // REGISTER EVENTS
    // =========================

    socket.on("newOrder", handleNewOrder);
    socket.on("acceptOrder", handleAcceptOrder);
    socket.on("declineOrder", handleDeclineOrder);
    socket.on("paid", handlePaid);
    socket.on("failed", handleFailed);
    socket.on("orderDeliveredpatron", handleOrderDeliveredPatron);
    socket.on("orderDeliveredmealhost", handleOrderDeliveredMealhost);
    socket.on("ratingByPatron", handleRatingByPatron);
    socket.on("ratingByMealhost", handleRatingByMealhost);
    socket.on("paymentSuccess", handlePaymentSuccess);

    // =========================
    // CLEANUP
    // =========================
    return () => {
      socket.off("newOrder", handleNewOrder);
      socket.off("acceptOrder", handleAcceptOrder);
      socket.off("declineOrder", handleDeclineOrder);
      socket.off("paid", handlePaid);
      socket.off("failed", handleFailed);
      socket.off("orderDeliveredpatron", handleOrderDeliveredPatron);
      socket.off("orderDeliveredmealhost", handleOrderDeliveredMealhost);
      socket.off("ratingByPatron", handleRatingByPatron);
      socket.off("ratingByMealhost", handleRatingByMealhost);
      socket.off("paymentSuccess", handlePaymentSuccess);
    };
  }, [navigate]);

  return null;
};

export default SocketConnection;
